import {getConfig} from '@/shared/lib/localStorage/internalAnalytics';
import {getCookieConsentDto} from '@/shared/lib/localStorage/signUp/cookieConsent';
import {notNullValues} from '@/shared/lib/object';

export type MetaData = {
  uuid: string;
  cookies: ReturnType<typeof getCookieConsentDto>;
};

export function getMetadata(): MetaData {
  return notNullValues({
    uuid: getConfig()?.uuid,
    cookies: getCookieConsentDto(),
  });
}
